// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/store'
import 'bulma'
import {auth} from './firebase/FirebaseInit'

Vue.config.productionTip = false

/* eslint-disable no-new */
let app

auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js